/**
 * EmptyState — icon + title + description + optional action.
 * Replaces 8+ ad-hoc empty surfaces across pages. Copy must be pt-BR.
 */

import { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        'rounded-2xl border border-dashed border-neutral-300 dark:border-neutral-700',
        'bg-neutral-50 dark:bg-neutral-900/50',
        'px-6 py-12 sm:py-16',
        className
      )}
      role="status"
    >
      {icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white dark:bg-neutral-800 text-muted-foreground shadow-sm">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
